<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="urlSecurite.non"

	[label]="step1.getspan6"
	[type]="'radio'"
	[rule]="''"
	[radios]="[
		{
			label: step1.getoui,
			value: 'Oui'
		},
		{
			label: step1.getnon,
			value: 'Non'
		}
	]"
	[name]="getUid() + '_SepAtt_non'"
>
</app-form-input>
<app-oui
	[uid]="getUid()"
	[parentForm]="parentForm"
	*ngIf="isUrlSecuriteOui()"
	[disabled]="disabled"
	[oui]="urlSecurite.oui"
></app-oui>
